module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isConnected) ? _c('ul', {
    staticClass: "nav navbar-nav selectedGroup"
  }, [_c('li', {
    ref: "dropdownElement",
    staticClass: "dropdown"
  }, [_c('a', {
    staticClass: "dropdown-toggle clickable",
    attrs: {
      "data-toggle": "dropdown"
    }
  }, [(_vm.selectedGroops) ? [(_vm.selectedGroops.length == 1) ? _c('vue-object-img', {
    attrs: {
      "object": _vm.firstSelectedGroop
    }
  }) : _c('i', {
    staticClass: "fa fa-group"
  }), _c('span', {
    staticClass: "text"
  }, [_vm._v(" " + _vm._s(_vm.selectedGroopsString))])] : [_vm._v(_vm._s(_vm.$t("globals.loading")))]], 2), (!_vm.isAllGroopsSelected) ? _c('div', {
    staticClass: "closeBtn",
    on: {
      "click": _vm.unselectGroup
    }
  }, [_c('i', {
    staticClass: "fa fa-times-circle"
  })]) : _c('div', {
    staticClass: "closeBtn",
    attrs: {
      "data-toggle": "dropdown"
    }
  }, [_c('i', {
    staticClass: "fa fa-caret-down"
  })]), _c('div', {
    ref: "dropdown",
    staticClass: "dropdown-menu dropdown-menu-left nopadding group-list"
  }, [_c('ul', {
    staticClass: "list"
  }, [_c('li', {
    staticClass: "dropdown-header"
  }, [_vm._v(_vm._s(_vm.$t("groups.explanation")))]), _c('li', {
    staticClass: "active",
    on: {
      "click": _vm.selectAllGroups
    }
  }, [_c('a', {
    staticClass: "clickable"
  }, [_c('vue-object-img', {
    attrs: {
      "object": _vm.user
    }
  }), _vm._v(_vm._s(_vm.$t('groups.allGroups')))], 1)]), _c('li', {
    on: {
      "click": _vm.selectPersonalGroup
    }
  }, [_c('a', {
    staticClass: "clickable"
  }, [_c('vue-object-img', {
    attrs: {
      "object": _vm.user
    }
  }), _vm._v(_vm._s(_vm.$t('groups.personalGroups')))], 1)]), (!_vm.groopsAreLoaded) ? [_c('li', {
    staticClass: "dropdown-header"
  }, [_vm._v(_vm._s(_vm.$t("globals.loading")))])] : [_vm._l((_vm.groupsAndType), function(typeAndGroups, key) {
    return [_c('li', {
      staticClass: "dropdown-header",
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.toggleShowInactiveGroupOfType(key)
        }
      }
    }, [(typeAndGroups.inactive.length > 0) ? [(_vm.groopTypeIsHidden(key)) ? _c('i', {
      staticClass: "fa fa-eye-slash notRecentlyUsedBtn",
      attrs: {
        "title": _vm.$t('groups.showUnusedGroups')
      }
    }) : _vm._e(), (!_vm.groopTypeIsHidden(key)) ? _c('i', {
      staticClass: "fa fa-eye notRecentlyUsedBtn",
      attrs: {
        "title": _vm.$t('groups.hideUnusedGroups')
      }
    }) : _vm._e()] : _vm._e(), _vm._v(" " + _vm._s(_vm.$t('groups.types.' + key)))], 2), _vm._l((typeAndGroups.active), function(group) {
      return _c('li', {
        on: {
          "click": function($event) {
            return _vm.selectGroup(group)
          }
        }
      }, [_c('a', {
        staticClass: "clickable",
        attrs: {
          "title": group.name,
          "data-tab": "members"
        }
      }, [_c('input', {
        class: {
          shown: !_vm.isAllGroopsSelected
        },
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "checked": _vm.groopInSelection(group)
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.toggleSelection(group)
          }
        }
      }), _c('vue-object-img', {
        attrs: {
          "object": group
        }
      }), _vm._v(" " + _vm._s(group.name)), _c('i', {
        staticClass: "fa fa-cog manageGroupBn",
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.toGroupManagement(group)
          }
        }
      }), _c('i', {
        staticClass: "fa fa-users manageMembersBn",
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.toMembers(group)
          }
        }
      })], 1)])
    }), (!_vm.groopTypeIsHidden(key)) ? _vm._l((typeAndGroups.inactive), function(group) {
      return _c('li', {
        on: {
          "click": function($event) {
            return _vm.selectGroup(group)
          }
        }
      }, [_c('a', {
        staticClass: "clickable",
        attrs: {
          "title": group.name
        }
      }, [_c('vue-object-img', {
        attrs: {
          "object": group
        }
      }), _c('input', {
        class: {
          shown: !_vm.isAllGroopsSelected
        },
        attrs: {
          "type": "checkbox"
        },
        domProps: {
          "checked": _vm.groopInSelection(group)
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.toggleSelection(group)
          }
        }
      }), _vm._v(" " + _vm._s(group.name)), _c('i', {
        staticClass: "fa fa-cog manageGroupBn",
        on: {
          "click": function($event) {
            return _vm.toGroupManagement(group)
          }
        }
      }), _c('i', {
        staticClass: "fa fa-users manageMembersBn",
        on: {
          "click": function($event) {
            return _vm.toMembers(group)
          }
        }
      })], 1)])
    }) : _vm._e()]
  })]], 2), (_vm.groopsAreLoaded) ? _c('ul', {
    staticClass: "footer"
  }, [_c('li', {
    on: {
      "click": function($event) {
        return _vm.createGroup()
      }
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" " + _vm._s(_vm.$t("groups.createAGroup")))])]), _c('li', {
    on: {
      "click": _vm.openMembers
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-user-plus"
  }), _vm._v(" " + _vm._s(_vm.$t("groups.createMembersModal.title")))])])]) : _vm._e()])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-625b49a8","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MainWrapper/HeaderGroupSelection.vue
// module id = 1269
// module chunks = 1